import UiArrows from "@/react/story/components/ui/UiArrows";
import UiColorPicker from "@/react/story/components/ui/UiColorPicker";
import UiDropzone from "@/react/story/components/ui/UiDropzone";
import UiRange from "@/react/story/components/ui/UiRange";
import { DEFAULTS } from "@/react/story/data";
import { type Arrows, type Config, type StoryPage, TypeEnum } from "@/react/story/types";
import InitUtils from "@/react/story/utils/InitUtils";
import TemplatingUtils from "@/react/story/utils/TemplatingUtils";

type Props = {
    page: StoryPage;
    setArrows: (arrows: Arrows | null) => void;
    setConfig: (config: Partial<Config>) => void;
}

export default function PageNavigation(props: Props) {
    return (
        <div className="d-flex flex-column gap-5">
            <div>
                <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
                    <h3 className="text-uppercase fs-4 mb-0">Flêches de déplacement</h3>
                    <button
                        type="button"
                        className={`btn btn-outline-${props.page.arrows ? "danger" : "secondary"}`}
                        onClick={() => props.setArrows(props.page.arrows ? null : {
                            "#type": TypeEnum.ARROWS,
                            uid: InitUtils.uid(),
                            config: InitUtils.config(),
                        })}
                    >
                        <span className={`bi-${props.page.arrows ? "dash" : "plus"}`}></span>
                    </button>
                </div>
                {props.page.arrows ? (
                    <UiArrows
                        arrows={props.page.arrows}
                        onChange={arrows => props.setArrows(arrows)}
                    />
                ) : null}
            </div>
            <div>
                <h3 className="text-uppercase fs-4">Arrière plan de la page</h3>
                <p className="text-muted small lh-sm">
                    Sera visible sur les écrans plus larges (tablettes, ordinateurs, …).
                </p>
                <div className="d-flex flex-column gap-3">
                    <div>
                        <strong className="d-block">Couleur</strong>
                        <UiColorPicker
                            color={props.page.config.backgroundColor}
                            onChange={backgroundColor => props.setConfig({ backgroundColor })}
                        />
                    </div>
                    <div>
                        <strong className="d-block">Image</strong>
                        <UiDropzone
                            defaultValue={props.page.config.backgroundImage}
                            canDelete={true}
                            onChange={backgroundImage => props.setConfig({ backgroundImage })}
                        />
                    </div>
                    {props.page.config.backgroundImage ? (
                        <div>
                            <strong className="d-block">Flou de l'image</strong>
                            <UiRange
                                max={20}
                                defaultValue={props.page.config.backdropFilter || DEFAULTS.backdropFilter}
                                onChange={backdropFilter => props.setConfig({ backdropFilter })}
                            />
                        </div>
                    ) : null}
                    <div>
                        <strong className="d-block">Prévisualisation</strong>
                        <div
                            className="rounded border"
                            style={{
                                height: "20rem", ...TemplatingUtils.style(props.page.config, null, [ "backdropFilter" ]),
                            }}
                        >
                            <div
                                className="d-flex justify-content-center align-items-center h-100"
                                style={{
                                    ...TemplatingUtils.style(props.page.config, [ "backdropFilter" ]),
                                }}
                            >
                                <div
                                    className="bg-dark"
                                    style={{
                                        width: "30%",
                                        height: "80%",
                                        ...TemplatingUtils.style(props.page.top.config),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
